export default "__VITE_ASSET__D7oKyS5o__"